import type {FetchVacancyPath, FetchVacancyResponse} from '../../http';
import {fetchVacancy} from '../../http';
import {useQuery, UseQueryOptions} from 'react-query';

export function useFetchVacancy(path: FetchVacancyPath, options?: UseQueryOptions<FetchVacancyResponse>) {
	return useQuery<FetchVacancyResponse>({
		queryKey: ['vacancy', path.id],
		queryFn: async ({signal}) => {
			const {data} = await fetchVacancy(path, signal);

			return data;
		},
		...options,
	});
}
